import {
  SectionAddressResults,
  TextFieldSearch,
  Sheet,
  SheetContentAddressDetails,
  Alert,
} from '@restaurant/core'
import { useWebAddressesPageViewModel } from '../viewmodels/pages/WebAddressesPageViewModel'

export default function AddressesPage() {
  const vm = useWebAddressesPageViewModel()

  return (
    <>
      <div
        className="w-full flex flex-col items-center py-6 gap-[var(--layout-space-07)]"
        data-testid="addresses-page"
      >
        {/* Search for new address */}
        <div className="w-full" style={{ maxWidth: 'var(--width-max-04)' }}>
          <TextFieldSearch
            value={vm.searchQuery}
            placeholder="Add a new address"
            onChange={vm.handleSearchChange}
            testID="addresses-search"
            accessibilityLabel="Search for a new delivery address"
          />
        </div>

        {/* Search results (shown when typing) or saved addresses (shown when empty) */}
        <div className="w-full" style={{ maxWidth: 'var(--width-max-04)' }}>
          {vm.searchQuery ? (
            vm.searchResults.length > 0 && (
              <SectionAddressResults
                addresses={vm.searchResults.map((r) => ({
                  id: r.id,
                  addressLine1: r.addressLine1,
                  addressLine2: r.addressLine2,
                }))}
                onAddressSelect={vm.handleSearchResultSelect}
                testID="addresses-search-results"
                accessibilityLabel="Address search results"
              />
            )
          ) : (
            <SectionAddressResults
              addresses={vm.badgedAddresses}
              onAddressSelect={vm.handleAddressSelect}
              testID="addresses-list"
              accessibilityLabel="Saved delivery addresses"
            />
          )}
        </div>
      </div>

      <Sheet
        isOpen={vm.isEditSheetOpen}
        onClose={vm.handleCloseSheet}
        title="Address Details"
        testID="address-edit-sheet"
      >
        {/* addressHeader fallback: getAddressDetailsProps() is typed
            Partial<...> so addressHeader is optional at the type level, but the
            ViewModel always returns it (defaulting to empty lines). The spread
            overrides this placeholder. */}
        <SheetContentAddressDetails
          addressHeader={{ addressLine1: '', addressLine2: '' }}
          {...vm.addressViewModel.getAddressDetailsProps()}
          mapComponent={vm.staticMapComponent}
          onEditAddress={vm.handleCloseSheet}
          onConfirmAddress={vm.handleConfirmAddress}
          testID="address-edit-content"
        />
      </Sheet>

      <Alert {...vm.alertProps} testID="addresses-delivery-alert" />
    </>
  )
}
